import {Alert, Button} from '@mui/material'
import {FC} from 'react'
import {useTranslation} from 'react-i18next'
import {useLocalStorage} from 'react-use'

import {FEATURE_NAMESPACE} from '../consts'

const EDIT_RUNTIMES_INFO_KEY = 'hide-edit-runtimes-info'

type RunningTimeEditInfoLabelProps = {
  isAdjustMode: boolean
}

export const RunningTimeEditInfoLabel: FC<RunningTimeEditInfoLabelProps> = ({isAdjustMode}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const [hideEditRuntimeInfo, setHideEditRuntimeInfo] = useLocalStorage(EDIT_RUNTIMES_INFO_KEY)

  return isAdjustMode && !hideEditRuntimeInfo ? (
    <Alert
      color="info"
      icon={false}
      sx={{mt: 2, alignItems: 'center'}}
      action={
        <Button
          onClick={() => setHideEditRuntimeInfo('true')}
          color="inherit"
          variant="text"
          size="small"
          data-test-id="hide-edit-runtime-info-button"
        >
          {t('stoppageAnalysis.action.ok').toUpperCase()}
        </Button>
      }
    >
      {t('stoppageAnalysis.message.adjustRuntimeInfo')}
    </Alert>
  ) : null
}
